import { render } from "./SettingsEmail.vue?vue&type=template&id=c784aebc&scoped=true"
import script from "./SettingsEmail.vue?vue&type=script&lang=js"
export * from "./SettingsEmail.vue?vue&type=script&lang=js"

import "./SettingsEmail.vue?vue&type=style&index=0&id=c784aebc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c784aebc"]])

export default __exports__